import { Content } from "shared/components/Content";
import { MEDIUM } from "shared/utils/constants";
import { Spacing } from "shared/components/Spacing";

export const RichTextSectionContainer = ({ body }) => (
  <Spacing size={MEDIUM}>
    <Content dropCapDisabled data={body} />
  </Spacing>
);
